
export const getUserAiAuth = async (userName: string, key: string) => {
  const response = await fetch('/json/auth/aiAuthToken', {
    method : 'POST',
    credentials: 'same-origin',
    headers: {
      'Accept' : 'application/json',
      'Content-Type': 'application/json',
      'userid': userName,
      'key': key
    }
  });
  const json = response.json();
  return json;
};
